/**
 * ANM22 World Plugin for Vue.js
 */

import functions from "./functions";
import tableClasses from "./tableClasses";
import icons from "./icons";
import { EventBus } from "./eventBus";

export default {
  install(Vue, options) {
    if (Vue.prototype.$anm22 == null) {
      Vue.prototype.$anm22 = {
        tableClasses: {},
        icons: {}
      };
    }
    /**
     * Mixins e EventBus per il dialogo fra componenti disaccoppiati
     */
    Object.assign(Vue.prototype.$anm22, {
      ...functions,
      eventBus: EventBus
    });
    /** */
    Object.assign(Vue.prototype.$anm22.tableClasses, tableClasses);
    Object.assign(Vue.prototype.$anm22.icons, icons);
  }
};
